import { Observable, SESSION_NOT_TRACKED, bridgeSupports, noop, performDraw, startSessionManager } from '@datadog/browser-core';
export var RUM_SESSION_KEY = 'rum';
export function startRumSessionManager(configuration, lifeCycle, trackingConsentState) {
  var sessionManager = startSessionManager(configuration, RUM_SESSION_KEY, function (rawTrackingType) {
    return computeTrackingType(configuration, rawTrackingType);
  }, trackingConsentState);
  sessionManager.expireObservable.subscribe(function () {
    lifeCycle.notify(9
    /* LifeCycleEventType.SESSION_EXPIRED */
    );
  });
  sessionManager.renewObservable.subscribe(function () {
    lifeCycle.notify(10
    /* LifeCycleEventType.SESSION_RENEWED */
    );
  });
  sessionManager.sessionStateUpdateObservable.subscribe(function (_ref) {
    var previousState = _ref.previousState,
        newState = _ref.newState;

    if (!previousState.forcedReplay && newState.forcedReplay) {
      var sessionEntity = sessionManager.findSession();

      if (sessionEntity) {
        sessionEntity.isReplayForced = true;
      }
    }
  });
  return {
    findTrackedSession: function findTrackedSession(startTime) {
      var session = sessionManager.findSession(startTime);

      if (!session || session.trackingType === "0"
      /* RumTrackingType.NOT_TRACKED */
      ) {
        return;
      }

      return {
        id: session.id,
        sessionReplay: session.trackingType === "1"
        /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
        ? 1
        /* SessionReplayState.SAMPLED */
        : session.isReplayForced ? 2
        /* SessionReplayState.FORCED */
        : 0
        /* SessionReplayState.OFF */
        ,
        anonymousId: session.anonymousId
      };
    },
    expire: sessionManager.expire,
    expireObservable: sessionManager.expireObservable,
    setForcedReplay: function setForcedReplay() {
      return sessionManager.updateSessionState({
        forcedReplay: '1'
      });
    }
  };
}
/**
 * Start a tracked replay session stub
 */

export function startRumSessionManagerStub() {
  var session = {
    id: '00000000-aaaa-0000-aaaa-000000000000',
    sessionReplay: bridgeSupports("records"
    /* BridgeCapability.RECORDS */
    ) ? 1
    /* SessionReplayState.SAMPLED */
    : 0
    /* SessionReplayState.OFF */

  };
  return {
    findTrackedSession: function findTrackedSession() {
      return session;
    },
    expire: noop,
    expireObservable: new Observable(),
    setForcedReplay: noop
  };
}

function computeTrackingType(configuration, rawTrackingType) {
  if (hasValidRumSession(rawTrackingType)) {
    return rawTrackingType;
  }

  if (!performDraw(configuration.sessionSampleRate)) {
    return "0"
    /* RumTrackingType.NOT_TRACKED */
    ;
  }

  if (!performDraw(configuration.sessionReplaySampleRate)) {
    return "2"
    /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */
    ;
  }

  return "1"
  /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
  ;
}

function hasValidRumSession(trackingType) {
  return trackingType === "0"
  /* RumTrackingType.NOT_TRACKED */
  || trackingType === "1"
  /* RumTrackingType.TRACKED_WITH_SESSION_REPLAY */
  || trackingType === "2"
  /* RumTrackingType.TRACKED_WITHOUT_SESSION_REPLAY */
  ;
}